"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlobStorageApiService = void 0;
var CommonService_decorator_1 = require("../decorators/CommonService.decorator");
var ServiceAddress_service_1 = require("./ServiceAddress.service");
var Url_service_1 = require("./Url.service");
var User_service_1 = require("./User.service");
var EXTERNAL_RESOURCES_CDN = 'https://smc-prod-cdn.seismic.com/static/external-resources';
var IMAGE_NOT_FOUND_URL = EXTERNAL_RESOURCES_CDN + "/images/ImageNotFound.png";
var BlobStorageApiService = /** @class */ (function () {
    function BlobStorageApiService(userService, serviceAddressService, urlService) {
        this.userService = userService;
        this.serviceAddressService = serviceAddressService;
        this.urlService = urlService;
    }
    /**
     * First gets the service addresses for tenant (if not cached)
     * Gets the url for an image to attach to img.src
     * @param blobId
     * @param requestSize
     */
    BlobStorageApiService.prototype.getImageUrl = function (blobId, requestSize) {
        if (requestSize === void 0) { requestSize = 'Origin'; }
        return __awaiter(this, void 0, void 0, function () {
            var tenant, baseURL;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tenant = this.userService.getTenant();
                        return [4 /*yield*/, this.serviceAddressService.getServiceAddressByKey('bss')];
                    case 1:
                        baseURL = _a.sent();
                        return [2 /*return*/, baseURL + "/api/image/v1/" + tenant + "/" + tenant + "/" + blobId + "?requestsize=" + requestSize];
                }
            });
        });
    };
    BlobStorageApiService.prototype.getFitImageURL = function (thumbnailRelativePathWithSignature, size, needDefaultImage) {
        if (needDefaultImage === void 0) { needDefaultImage = true; }
        return __awaiter(this, void 0, void 0, function () {
            var domain, baseURL;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!thumbnailRelativePathWithSignature) {
                            return [2 /*return*/, ''];
                        }
                        return [4 /*yield*/, this.serviceAddressService.getServiceAddressByKey('bss')];
                    case 1:
                        domain = _a.sent();
                        baseURL = this.urlService.normalizeDomain(domain);
                        return [2 /*return*/, baseURL + this.getFitImageURLPath(thumbnailRelativePathWithSignature, size, needDefaultImage)];
                }
            });
        });
    };
    BlobStorageApiService.prototype.getFitImageURLSync = function (baseURL, thumbnailRelativePathWithSignature, size, needDefaultImage) {
        if (needDefaultImage === void 0) { needDefaultImage = true; }
        return this.urlService.normalizeDomain(baseURL) + this.getFitImageURLPath(thumbnailRelativePathWithSignature, size, needDefaultImage);
    };
    BlobStorageApiService.prototype.getFitImageURLPath = function (thumbnailRelativePathWithSignature, size, needDefaultImage) {
        if (!thumbnailRelativePathWithSignature) {
            return '';
        }
        var requestSize = size || 'SmallMedium';
        var redirecturi = needDefaultImage ? IMAGE_NOT_FOUND_URL : null;
        return thumbnailRelativePathWithSignature + "&" + this.urlService.getURLParametersAsString({ requestSize: requestSize, redirecturi: redirecturi });
    };
    BlobStorageApiService = __decorate([
        CommonService_decorator_1.CommonService('BlobStorageApiService'),
        __metadata("design:paramtypes", [User_service_1.UserService,
            ServiceAddress_service_1.ServiceAddressService,
            Url_service_1.UrlService])
    ], BlobStorageApiService);
    return BlobStorageApiService;
}());
exports.BlobStorageApiService = BlobStorageApiService;
//# sourceMappingURL=BlobStorageApi.service.js.map